<template>
  <layout title="Professores" :options="options" :rotas="rotas">
    <ReportAvulse v-if="tabs == 0 && get_permission_user['report']" />
    <EvaluationAvulse v-if="tabs == 1" />
    <TeacherAvulse v-if="tabs == 2 && get_permission_user['teacher']" />
    <StudentAvulse v-if="tabs == 3" />
    <v-bottom-navigation :background-color="$theme.primary" fixed bottom>
      <v-btn 
        :value="menu.name"
        v-for="(menu, index) in menus"
        active-class="black--text"
        :key="`item-menu-${index}`"
        :class="{ 'font-weight-bold black--text': tabs == index }"
        @click="menu.action2"
        v-show="menu.permission()"
        class="px-6"
        :id="`item-menu-${index}`"
      >
        <span class="fonte fonteMini">{{ menu.name }}</span>

        <v-icon>{{ menu.icon }}</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </layout>
</template>

<script>
import TeacherAvulse from "@/apps/Teacher/views/Avulse.vue";
import StudentAvulse from "@/apps/Student/views/Avulse.vue";
import ReportAvulse from "@/apps/Report/views/Avulse.vue";
import EvaluationAvulse from "@/apps/Evaluation/views/Avulse.vue";
import { mapGetters } from 'vuex';

export default {
  components: {
    TeacherAvulse,
    StudentAvulse,
    ReportAvulse,
    EvaluationAvulse
  },
  data() {
    return {
      options: [],
      rotas: [
        {
          name: "Início",
          path: "/inicio-admin"
        },
      ],
      tabs: 0,
      menus: [
        {
          icon: "mdi-clipboard-text-outline",
          name: "Relatório",
          route: "/relatorio",
          action2: () => this.tabs = 0,
          permission: () => this.get_permission_user["report"]
        },
        {
          icon: "mdi-clipboard-clock-outline",
          name: "Avaliações",
          route: "/avaliacoes",
          action2: () => this.tabs = 1,
          permission: () => true
        },
        {
          icon: "mdi-human-male-board",
          name: "Professores",
          route: "/professores",
          action2: () => this.tabs = 2,
          permission: () => this.get_permission_user["teacher"]
        },
        {
          icon: "mdi-account-school-outline",
          name: "alunos",
          route: "/alunos",
          action: () => this.$router.push("/alunos"),
          action2: () => this.tabs = 3,
          permission: () => true
        },
      ]
    };
  },
  computed: {
    ...mapGetters([
      "get_permission_user"
    ])
  },
  mounted() {
    if (this.get_permission_user["report"]) {
      document.getElementById("item-menu-0").click();
      this.tabs = 0
    } else {
      document.getElementById("item-menu-1").click();
      this.tabs = 1
    }
  }
};
</script>

<style scoped>
.sheet-container {
  min-height: 96vh;
  max-height: 96vh;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
.item-list {
  background-color: #fff;
  border-radius: 6px;
  border: 1px solid #1173ff;
}
</style>
